import { render } from "./Paso5LugarSalidaComponent.vue?vue&type=template&id=a1a3ce2c"
import script from "./Paso5LugarSalidaComponent.vue?vue&type=script&lang=js"
export * from "./Paso5LugarSalidaComponent.vue?vue&type=script&lang=js"

import "./Paso5LugarSalidaComponent.vue?vue&type=style&index=0&id=a1a3ce2c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__